import Container from "./container";
import Text from "./text";
import Break from "./break";
import Cursor from "./cursor";
// import AsideTours from "./asideTours";
// import AsideContainer from "./asideContainer";

class Aside extends Container {

}

Aside.blotName = 'aside';
Aside.tagName = 'ASIDE';
Aside.allowedChildren = [Text, Break, Cursor/*, AsideTours*/];
// Aside.requiredContainer = AsideContainer;

export default Aside;